import {createProjectModel} from 'crm/utils/project-model'
import {tasksInfo, createTasks, tasksModify} from './service'

const model = createProjectModel({
    projectNamespace: 'GroupSopModify',

    state: {},

    effects: {
        *createTasks({payload}, {call}) {
            return yield call(createTasks, payload)
        },

        *tasksModify({payload}, {call}) {
            return yield call(tasksModify, payload)
        },

        *tasksInfo({payload}, {call}) {
            return yield call(tasksInfo, payload)
        },
    },
})

export default model
